import React from "react";
import Button, { Variant } from "@components/buttons/Button/Button";
import Card from "@components/cards/Card/Card";
import styles from "./BasePricingCard.module.css";

type BasePricingCardProps = {
    title: string;
    buttonText: string;
    onButtonClick: () => void;
    variant?: Variant;
    disableButton?: boolean;
    children?: React.ReactNode;
};

const BasePricingCard: React.FC<BasePricingCardProps> = ({
    title,
    buttonText,
    onButtonClick,
    variant = "submit",
    disableButton,
    children,
}) => {
    return (
        <Card className={styles.pricingCard}>
            <h3 className={styles.title}>{title}</h3>
            {children}
            <Button
                onClick={onButtonClick}
                variant={variant}
                size="medium"
                disabled={disableButton}
            >
                {buttonText}
            </Button>
        </Card>
    );
};

export default BasePricingCard;
